import { Box, Typography } from '@mui/material';
import JobCard from '../shared/job-card/job-card.component';
import { useJDStyles } from './job-details.styles';

const JobDetails = ({ job }) => {
  const classes = useJDStyles();

  const covertStringToList = (string, seperator) => {
    return string.split(seperator);
  };

  return (
    <Box
      display='flex'
      sx={{
        '@media (max-width: 650px)': {
          flexDirection: 'column',
          alignItems: 'center',
        },
      }}
    >
      <JobCard job={job} />
      <Box
        marginLeft='70px'
        sx={{
          '@media (max-width: 650px)': {
            marginLeft: '0 !important',
            marginTop: '30px',
          },
        }}
      >
        <Box component='ul' className={classes.jdResponsiblities}>
          <Typography sx={{ fontWeight: '600' }}>Responsibilities</Typography>
          {covertStringToList(job.responsiblities, '$').map(
            (responsibility) => (
              <Box component='li' key={responsibility}>
                {responsibility}
              </Box>
            )
          )}
        </Box>

        <Box component='ul' className={classes.jdQualifications}>
          <Typography sx={{ fontWeight: '600' }}>Qualifications</Typography>
          {covertStringToList(job.qualifications, '$').map((qualification) => (
            <Box component='li' key={qualification}>
              {qualification}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default JobDetails;
